import { DRAFT_EVIDENCE } from 'src/api';
import axios from 'src/axios';
import { handleErrorToast } from 'src/components/molecules';
import { File } from 'src/components/moleculesLegacy/FileUpload';
import { CaseDocuments, MCCFile } from 'src/types';

export const getEvidence = async (
  reportId: string,
  mccFiles: MCCFile[],
  setFiles: (files: File[]) => void,
) => {
  try {
    const res = await axios.get(DRAFT_EVIDENCE(reportId));
    const fileIds = mccFiles.map((file) => file.id);
    const files = res.data
      .filter((file: CaseDocuments) => fileIds.includes(file.s3path))
      .map((file: CaseDocuments) => ({
        source: file.s3path,
        options: {
          type: 'local',
          file: {
            name: file.filename,
            size: file.size,
            type: file.mimeType,
          },
          metadata: {
            scanStatus: file.scanStatus,
          },
        },
        status: 2, // FilePond IDLE status for server-loaded files
      }));
    setFiles(files);
  } catch (error) {
    handleErrorToast({ toastMessage: 'Could not get event evidence' });
  }
};
